export const isKeyClick = (e: React.KeyboardEvent<any>): boolean => {
  return e.code === 'Enter' || e.code === 'Space';
};
